module.exports = __webpack_public_path__ + "static/media/4.cea5636b.jpg";